import axios from 'axios';
import router from '@/router';
import storage from 'store';
import store from '@/store';
import { Message, Loading } from 'element-ui';
import DOMPurify from 'dompurify'; //预防Xss攻击 过滤数据
// 请求拦截器
const language = {
  zh: 'zh-CN,zh;',
  vi: 'vi-VN,vi;',
  en: 'en-US,en;'
};
const HTTP = axios.create({
  baseURL: process.env.NODE_ENV ? '/api' : ''
});

HTTP.interceptors.request.use((config) => {
  config.headers['accept-Language'] = language[storage.get('app_language')];
  if (router.currentRoute.path != '/user/login') {
    config.headers.token = storage.get('access_token');
  }

  //进行api的权限拦截
  return config;
});

// 响应拦截器
HTTP.interceptors.response.use(
  (config) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (config.config.url.includes('/export')) {
      // 跳过导出请求的拦截处理
      return config;
    }
    if (config.data && config.data.data) {
      try {
        let save = JSON.parse(DOMPurify.sanitize(JSON.stringify(config.data.data)));
        config.data.data = save;
        console.log('🚀 ~ configsave:', config);
      } catch (error) {
        console.error('解析错误：', error.message, '🚀 ~ configsave-err:', config);
      }
    }
    if (config.status == 200) {
      if (config.data.code == 601) {
        store.dispatch('loginOut');
        router.push({ name: 'login' });
        return config;
      } else if (config.data.code == 500) {
        // Message.error('服务器内部错误');
      } else if (
        config.data.code != undefined &&
        !['0', '200', 200, 0].includes(config.data.code)
      ) {
        if (config.data.msg) {
          //工作区间的商户钱包余额 不要错误提示语
          if (!window.location.pathname.includes('dashboard')) {
            Message.error(config.data.msg);
          }
        }
      }
      return config;
    } else {
      return Promise.reject();
    }
  },
  // 服务器状态码不是2开头的的情况
  (error) => {
    if (error.response.status) {
      console.log('错误状态码:' + error.response.status);
      switch (error.response.status) {
        //服务端内部错误
        case 404:
          Message.error('请求路径错误');
          break;

        //服务端内部错误
        case 500:
          Message.error('服务端内部错误');
          break;

        default:
          //2.提示
          Message.error(error.response.text);
      }
      return Promise.reject(error);
    }
  }
);

HTTP.loading = (...params) => {
  const loading = Loading.service({ fullscreen: true });
  return new Promise((resolve, reject) => {
    HTTP(...params).then(
      (res) => {
        loading.close();
        resolve(res);
      },
      (err) => {
        loading.close();
        reject(err);
      }
    );
  });
};

export default HTTP;



// WEBPACK FOOTER //
// ./src/plugins/http.js